export default function Machines_A_7 (number = 1) {
  return {
    name: '蓄电池(满)',
    icon: '/static/img/machines/a7.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_7.js